(function(AjaxDataTypes) {
    function isIStripeCheckoutRequestStatus(object) {
        return typeof object.status == 'boolean' && typeof object.message == 'string';
    }
    AjaxDataTypes.isIStripeCheckoutRequestStatus = isIStripeCheckoutRequestStatus;
    class PublicProfileDataStickyPlayerInfo {
        constructor(){
            this.username = '';
        }
    }
    AjaxDataTypes.PublicProfileDataStickyPlayerInfo = PublicProfileDataStickyPlayerInfo;
    class PublicProfileDataOverview {
        constructor(){
            this.username = '';
            this.karma = '';
            this.gameData = new PublicProfileGameDataOverview();
        }
    }
    AjaxDataTypes.PublicProfileDataOverview = PublicProfileDataOverview;
    class PublicProfileGameDataOverview {
        constructor(){
            this.pointsInLast100Games = 0;
            this.totalGames = 0;
            this.winPercent = '0';
            this.pointsPerGame = '0';
        }
    }
    AjaxDataTypes.PublicProfileGameDataOverview = PublicProfileGameDataOverview;
    class UserFriendsData {
        constructor(){
            this.friends = [];
            this.friendRequestsSent = [];
            this.friendRequestsReceived = [];
        }
    }
    AjaxDataTypes.UserFriendsData = UserFriendsData;
    class FriendRequestReceivedData {
    }
    AjaxDataTypes.FriendRequestReceivedData = FriendRequestReceivedData;
})(AjaxDataTypes || (AjaxDataTypes = {}));
export var AjaxDataTypes;
